import "./Capabilities.css";
import Footer from "./Footer";

import solimg13 from "../assets/sol-img13.png";
import solimg12 from "../assets/sol-img12.png";


export default function CapQuality() {
  return (
    <section id="cap-qua">
      {/* TOP SECTION */}
      <div className="capability-wrapper-a">
        {/* LEFT CONTENT */}
        <div className="capability-text-a">
          <h3>Quality</h3>
          <h3>
            Assuring Precision. Enabling Performance. Quality that drives reliability in every cast.
          </h3>

          <p>
            Quality begins with a mindset: TQM and a “Zero Defect” mindset at SCL are the foundations of consistent quality. Product quality is built into every process, from design and development to manufacturing and delivery. 
          </p>
        </div>
      </div>

      <div className="img-grid">
        <img src={solimg13} alt="solutions" />
        <img src={solimg12} alt="solutions" />
        
      </div>

      <h2 className="capability-title">Our Quality Process</h2>
      <div className="cap-underline"></div>
      <p style={{ textAlign: "center", margin: "30px 220px" }}>We follow a structured, end-to-end quality framework to assure excellence from concept to customer.</p>

      <div className="cap-wrapper1">
        {/* SINGLE MERGED CARD */}
        <div className="cap-card">
          <div className="cap-header">
            Our Quality Framework – From Concept to Customer
          </div>

          <div className="cap-body">
            <h4>Design &amp; Simulation</h4>
            <p>
              Early quality begins at the design stage. Feasibility studies, risk assessments, and DFMEA reviews ensure robust, defect-free designs and manufacturability.
            </p>

            <h4>Tooling &amp; Process Development</h4>
            <p>
              Dies and fixtures are validated through dimensional checks and process capability studies, securing readiness for stable and repeatable production.
            </p>

            <h4>Casting &amp; Manufacturing</h4>
            <p>
              Real-time process monitoring and SPC-based controls prevent defects at source and maintain uniform casting quality across production.
            </p>

            <h4>Inspection, Testing &amp; Delivery</h4>
            <p>
              CMM, 3D scanning, X-Ray and leak testing, supported by full traceability, final audits and packing QA, verify dimensional accuracy, internal integrity and compliance with global OEM standards.
            </p>
          </div>
        </div>
      </div>

      <h2 className="capability-title">Core Quality Capabilities</h2>
      <div className="cap-underline"></div>
      <div className="cap-wrapper">
        {/* CARD 1 */}
        <div className="cap-card">
          <div className="cap-header">
            CMM & 3D Scanning Systems
          </div>

          <div className="cap-body">
            <p>
              High-precision CMMs and 3D scanners validate complex geometries and support reverse engineering and design optimization.
            </p>
          </div>
        </div>

        {/* CARD 2 */}
        <div className="cap-card">
          <div className="cap-header">
            X-ray & Leak Testing Stations
          </div>

          <div className="cap-body">
            <p>
              Automated X-ray and helium leak testing detect hidden internal defects, ensuring fail-safe performance in safety-critical applications.
            </p>
          </div>
        </div>

        {/* CARD 3 */}
        <div className="cap-card">
          <div className="cap-header">
            Real-time Process Monitoring
          </div>

          <div className="cap-body">
            <p>
              Online monitoring of key process parameters provides instant alerts, trend tracking, and root-cause analysis for continuous improvement.
            </p>
          </div>
        </div>
      </div>
      <div className="cap-wrapper2">
        <div className="cap-card">
          <div className="cap-header">
            Occurrence Monitoring Charts
          </div>

          <div className="cap-body">
            <p>
              Weekly defect dashboards and occurrence charts drive ownership on the shop floor and enable data-based decision-making.
            </p>
          </div>
        </div>

        <div className="cap-card">
          <div className="cap-header">
            Audit-ready Documentation Framework
          </div>

          <div className="cap-body">
            <p>
              Digital documentation aligned with IATF 16949 supports layered process audits, customer-specific requirements and seamless audit readiness.
            </p>
          </div>
        </div>
      </div>


      <Footer />
    </section>
  );
}
